import React, { useEffect, createElement } from 'react';
import { useLocation } from 'react-router-dom';
interface GoogleAnalyticsProps {
  measurementId: string;
}
export function GoogleAnalytics({
  measurementId
}: GoogleAnalyticsProps) {
  const location = useLocation();
  useEffect(() => {
    // Load Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}', {
        page_path: window.location.pathname,
        anonymize_ip: true,
        cookie_flags: 'SameSite=None;Secure'
      });
    `;
    document.head.appendChild(script2);
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, [measurementId]);
  // Track page views on route change
  useEffect(() => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('config', measurementId, {
        page_path: location.pathname + location.search
      });
    }
  }, [location, measurementId]);
  return null;
}